module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"learn_more":"Подробнее"},"en":{"learn_more":"Learn more"}}')
  delete Component.options._Ctor
}
